import Icon from "@ant-design/icons";
import { type FunctionComponent } from "react";

import SVG from "images/ReceiptsEnrichedLight.svg?react";

import { type IBTIconProps } from "../BTIcon.types";
import { useBaseIcon } from "../BTIcon.utilities";

export const BTIconReceiptsEnrichedLight: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useBaseIcon(baseProps);

    // eslint-disable-next-line react/forbid-elements
    return <Icon {...props} component={SVG} />;
};
